// The deep link to one contact: /contact/<convNumber>, the URL the address
// bar shows for a selected contact (App.jsx's History API handling), or '/'
// when there is no number. Shared so every "open this contact" link builds the
// same URL.
export function convNumberPath(convNumber) {
  return convNumber != null ? `/contact/${convNumber}` : '/'
}
